import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { ActivosService } from '../../../../../auxiliares/servicios/http/activos.service';
import { ICliente } from 'modelos/src';

@Component({
  selector: 'app-sincronizar-soflex',
  templateUrl: './sincronizar-soflex.component.html',
  styleUrl: './sincronizar-soflex.component.scss',
  standalone: false,
})
export class SincronizarSoflexComponent {
  helper = inject(HelperService);
  private service = inject(ActivosService);
  dialogRef = inject<MatDialogRef<SincronizarSoflexComponent>>(MatDialogRef);

  public loading = false;
  public clienteSeleccionado?: ICliente;
  public modoTest = true;
  public resultado?: {
    success: boolean;
    message: string;
    activosSincronizados?: number;
    urlSimulacion?: string;
    urlBodies?: string;
  };

  public onClienteChange(cliente: ICliente | null): void {
    this.clienteSeleccionado = cliente || undefined;
  }

  public async sincronizar(): Promise<void> {
    const idCliente = this.clienteSeleccionado?._id;
    if (!idCliente) {
      this.helper.notifError('Seleccioná un cliente a sincronizar');
      return;
    }

    this.loading = true;
    this.resultado = undefined;
    try {
      const res = await this.service.sincronizarSoflex(
        idCliente,
        this.modoTest,
      );
      this.resultado = res;

      if (res.success) {
        this.helper.notifSuccess(res.message);
      } else {
        this.helper.notifError(res.message);
      }
    } catch (error: any) {
      console.error(error);
      const esErrorDeRed = error?.status === 0;
      const mensaje = esErrorDeRed
        ? 'No se pudo conectar con el servidor. Es posible que la operación haya tardado demasiado. Intentá nuevamente.'
        : `Error: ${error?.message || error}`;
      this.helper.notifError(mensaje);
      this.resultado = { success: false, message: mensaje };
    }
    this.loading = false;
  }

  public cerrar(): void {
    this.dialogRef.close(this.resultado);
  }

  public onModoTestChange(event: any): void {
    this.modoTest = event.checked;
  }

  public getResultadoMessage(): string {
    if (!this.resultado) return '';
    let message = this.resultado.message;
    if (this.resultado.activosSincronizados) {
      message += `<br/><strong>Activos procesados:</strong> ${this.resultado.activosSincronizados}`;
    }
    return message;
  }
}
